/**
 * The assistant's avatar: a four-point sparkle drawn as inline SVG.
 *
 * SVG rather than an emoji or a glyph character because emoji render differently on every OS (and at
 * this size read as decoration), while a path is identical everywhere and can be animated.
 * `busy` speeds the animation up while a turn is streaming, so the mark doubles as a liveness cue.
 */
export default function AgentMark({ busy = false }) {
  return (
    <div className={"avatar ai" + (busy ? " busy" : "")} aria-label="Assistant">
      <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
        <path
          d="M12 1.6l2.05 7.05a1 1 0 0 0 .68.68L21.8 11.4a.63.63 0 0 1 0 1.2l-7.07 2.07a1 1 0 0 0-.68.68L12 22.4a.63.63 0 0 1-1.2 0l-2.05-7.05a1 1 0 0 0-.68-.68L1 12.6a.63.63 0 0 1 0-1.2l7.07-2.07a1 1 0 0 0 .68-.68z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
